import { useEffect, useState } from "react"
import moment from "moment"
import styled from "styled-components"
import { FaEnvelope, FaPlay } from "react-icons/fa"
import { Button } from "@prosolve/common-components-ui"
import Table from "../../shared/Table"
import { checkHasEditJobsPermissions, getEnv } from "../../utils"
import useDataJobs from "../../dataHooks/useDataJobs"
import TestRunModal from "./TestRunModal"
import EventAttendeeRemindersEmailModal from "./EventAttendeeRemindersEmailModal"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 0;
`

const RowGroup = styled.div`
  display: flex;
  gap: 10px;
`

const FlexStart = styled.div`
  display: flex;
  gap: 10px;
  flex: 1;
`

const FlexEnd = styled(FlexStart)`
  justify-content: flex-end;
`

const EmptyMessage = styled.div`
  color: #565656;
  padding: 20px 0px;
`

const ActionsWrapper = styled.div`
  display: flex;
  gap: 5px;
  padding: 8px 0;
  height: 24px;
`

export default ({
  onLoad
}) => {
  const [isShowEmailModal, setIsShowEmailModal] = useState()
  const [isShowTestRunModal, setIsShowTestRunModal] = useState()

  const { isLoading, attendeesForEventReminders, fetchAttendeesForEventReminders, fetchRunAttendeeEventReminderEmail } = useDataJobs()

  const hasEdit = checkHasEditJobsPermissions()
  const isQa = getEnv() === 'qa'

  useEffect(() => {
    fetchAttendeesForEventReminders()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    onLoad?.(attendeesForEventReminders)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attendeesForEventReminders])

  const formatDate = ({ value }) => value ? moment(value).format("MM/DD/YYYY") : ""

  const columns = [
    { headerName: "Attendee", field: "name" },
    { headerName: "Attendee Id", field: "id" },
    { headerName: "Email", field: "email" },
    { headerName: "Event Id", field: "eventId" },
    { headerName: "Event", field: "eventName" },
    { headerName: "Event Start", field: "eventStartDate", valueFormatter: formatDate },
    { headerName: "Status", field: "requestStatus" },
    { headerName: "Emails Sent", field: "emailsSent", tooltipField: 'emailsSent' },
    { headerName: "Email Type", field: "emailType" },
    { 
      headerName: 'Actions',
      cellRenderer: ({ data }) => {
        return (
          <ActionsWrapper>
            <Button onClick={() => setIsShowEmailModal({ attendee: data })}><FaEnvelope /></Button>
            <Button onClick={() => handleTestRunModal({ attendeeId: data.id })}><FaPlay /><span>*</span></Button>
            {!isQa &&
              <Button onClick={() => handleRun({ attendeeId: data.id })}><FaPlay /></Button>
            }
          </ActionsWrapper>
        )
      }
    },
  ]

  const handleShowEmailExample = () => {
    setIsShowEmailModal({
      attendee: {
        name: '[Name]',
        email: '[Email@mail.com]',
        eventId: '[12345]',
        eventName: '[Example Event]',
        eventStartDate: '2019-03-18',
        addressStreet: '[street]',
        addressCity: '[city]',
        addressState: '[state]',
        addressZip: '[zip]',
        timeZone: 'EST',
        clientContactEmail: '[clientContact@mail.com]',
        sessions: [
          {
            startTime: '06:00:00.000Z',
            endTime: '08:00:00.000Z'
          }
        ]
      }
    })
  }

  const handleTestRunModal = (props) => {
    setIsShowTestRunModal({ data: props })
  }

  const handleTestRun = (props) => {
    fetchRunAttendeeEventReminderEmail(props)
  }

  const handleRun = ({ attendeeId }) => {
    if (window.confirm('Please confirm you want to run this process. Emails will be sent out to users.')) {
      fetchRunAttendeeEventReminderEmail({ attendeeId })
    }
  }

  return (
    <Container>
      <RowGroup>
        <Button onClick={handleShowEmailExample} style={{ width: '200px' }}>
          <FaEnvelope style={{ paddingRight: '5px' }} />
          Example Email
        </Button>
        
        {hasEdit &&
        <>
          <FlexEnd>
            <Button onClick={() => handleTestRunModal()} style={{ width: '200px' }}>
              <FaPlay /><span style={{ paddingRight: '5px' }}>*</span>
              Test Run
            </Button>
            
            {!isQa &&
              <Button onClick={handleRun} style={{ width: '200px' }}>
                <FaPlay style={{ paddingRight: '5px' }} />
                Manual Run
              </Button>
            }
          </FlexEnd>
        </>
        }
      </RowGroup>

      {
        (attendeesForEventReminders || []).length > 0 || isLoading
          ? (
            <Table
              data={attendeesForEventReminders}
              cols={columns}
              isLoading={isLoading}
            />
          )
          : <EmptyMessage>No reminders found.</EmptyMessage>
      }

      {isShowEmailModal &&
        <EventAttendeeRemindersEmailModal {...isShowEmailModal} onClose={() => setIsShowEmailModal()} />
      }
      
      {isShowTestRunModal &&
        <TestRunModal {...isShowTestRunModal} onClose={() => setIsShowTestRunModal()} onSuccess={handleTestRun} />
      }
    </Container>
  )
}
